import { render } from "./VocabCard.vue?vue&type=template&id=4ad297c0"
import script from "./VocabCard.vue?vue&type=script&lang=js"
export * from "./VocabCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\cram_srs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__